import { createSlice } from '@reduxjs/toolkit';

import { paymentsApi } from './payments-api';

import type { TPaymentsState } from './types';

const initialState: TPaymentsState = {
  approvedDelay: 0,
  approvedWrongAmount: 0,
};

export const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    build
      .addMatcher(paymentsApi.endpoints.getPaymentsAwaitingApproval.matchFulfilled, (state: TPaymentsState, action) => {
        state.approvedDelay = action.payload;
      })
  },
});
